import { Link } from "react-router";
import { Fragment } from "react";

import "../assets/scss/components/_home-upsell.scss";
import MaroonLogo from "../assets/images/123-Logo-Horizontal-Maroon.png";
import { Image } from "./Image";
import { Slider } from "./Slider";

export const HomeUpsell = ({ slides = [] }) => {
	return (
		<>
			<section className={`home-upsell`}>
				{slides.length > 0 && (
					<Slider
						slides={slides.map((slide, index) => ({
							element: (
								<HomeUpsellSlide
									key={slide.id}
									slide={slide}
									isFirst={index === 0}
								/>
							),
						}))}
						prefix="home-upsell-slider"
						slides_per_row={{ base: 1, md: 1 }}
						autoplay={true}
						slide_duration={3}
						arrows={true}
					/>
				)}
			</section>
		</>
	);
};

const HomeUpsellSlide = ({ slide, isFirst }) => {
	let logos = [];
	if (slide.link == "/flowers-with-teddy") {
		logos = [{ "123 Flowers": MaroonLogo }];
	}

	return (
		<div
			className="biggest-trends"
			style={{
				"--bg": slide.background_color_override || "",
				"--color": slide.button_color_override || "",
			}}
		>
			<div className="row align-items-stretch no-wrap">
				<div className="upsell-img col-12">
					<Image
						src={slide.image}
						alt={slide.title}
						imported={true}
						loading={isFirst ? "eager" : "lazy"}
						fetchPriority={isFirst ? "high" : "auto"}
						sizes="100vw"
						width={1920}
						height={400}
						// The API image URL already includes CDN transformations.
						srcSet={undefined}
					/>
				</div>

				<div className={`col-12 col-lg-8 trend-description`}>
					{logos.length > 0 ? (
						<div className="upsell-logos">
							{logos.map((logo, index) => {
								const [alt, src] = Object.entries(logo)[0];
								return (
									<Fragment key={index}>
										<img
											className="upsell-logo"
											key={index}
											src={src as string}
											alt={alt as string}
										/>
										{index === 0 ? <strong className="upsell-x">X</strong> : null}
										<strong className="upsell-title">{slide.title}</strong>
									</Fragment>
								);
							})}
						</div>
					) : (
						<strong className="upsell-title">{slide.title}</strong>
					)}

					<p className="upsell-description">{slide.subtitle}</p>

					<Link
						to={slide.link}
						className="btn minimal"
						style={slide.button_color_override ? { backgroundColor: slide.button_color_override } : {}}
					>
						{slide.button_text_override ?? "Shop Now"}
					</Link>
				</div>
			</div>
		</div>
	);
};
